import { ClearOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useEffect, useState } from "react";

const Dash = ({ data, setType }) => {
  const getCounts = () => {
    let itoolsCount = 0;
    let packmnCount = 0;
    let onlineCount = 0;
    let offlineCount = 0;
    let activeCount = 0;

    data?.forEach((x) => {
      if (x.broker === "itools") itoolsCount++;
      if (x.broker === "packmn") packmnCount++;
      if (x.status === "online") onlineCount++;
      if (x.status === "offline") offlineCount++;
      if (x.isactive === 1) activeCount++;
    });

    return {
      itoolsCount,
      packmnCount,
      onlineCount,
      offlineCount,
      activeCount,
    };
  };

  let counts = getCounts();

  return (
    <div className="grid col-span-2 md:grid-cols-4 lg:grid-cols-6 gap-2">
      <div
        className="flex flex-col border rounded-md shadow-lg p-3 items-end gap-1 cursor-pointer"
        onClick={() => setType(1)}
      >
        <span>Нийт холбогдсон машинууд</span>
        <span className="font-bold text-xl text-active">{data?.length}</span>
      </div>
      <div
        className="flex flex-col border rounded-md shadow-lg p-3 items-end gap-1 cursor-pointer"
        onClick={() => setType(2)}
      >
        <span>Pack.mn холбогдсон машинууд</span>
        <span className="font-bold text-xl text-active">
          {counts?.packmnCount}
        </span>
      </div>
      <div
        className="flex flex-col border rounded-md shadow-lg p-3 items-end gap-1 cursor-pointer"
        onClick={() => setType(3)}
      >
        <span>Itools холбогдсон машинууд</span>
        <span className="font-bold text-xl text-active">
          {counts?.itoolsCount}
        </span>
      </div>
      <div
        className="flex flex-col border rounded-md shadow-lg p-3 items-end gap-1 cursor-pointer"
        onClick={() => setType(4)}
      >
        <span>Нийт online машинууд</span>
        <span className="font-bold text-xl text-active">
          {counts?.onlineCount}
        </span>
      </div>
      <div
        className="flex flex-col border rounded-md shadow-lg p-3 items-end gap-1 cursor-pointer"
        onClick={() => setType(5)}
      >
        <span>Нийт offline машинууд</span>
        <span className="font-bold text-xl text-active">
          {counts?.offlineCount}
        </span>
      </div>
      <div
        className="flex flex-col border rounded-md shadow-lg p-3 items-end gap-1 cursor-pointer"
        onClick={() => setType(6)}
      >
        <span>Нийт одоо асаалттай машинууд</span>
        <span className="font-bold text-xl text-active">
          {counts?.activeCount}
        </span>
      </div>
    </div>
  );
};

const Index = (props) => {
  const [data, setData] = useState([]);
  const [type, setType] = useState(0);
  useEffect(() => {
    const fetchData = () => {
      props
        ?.request({
          url: "/action/getallcar",
          type: "socket",
        })
        ?.then((res) => {
          if (res?.success) {
            setData(res?.data);
          }
        });
    };

    fetchData();

    const interval = setInterval(() => {
      fetchData();
    }, 30000);

    return () => clearInterval(interval);
  }, []);

  const renderCars = () => {
    let cars = [];
    if (type === 1) {
      cars = data;
    } else if (type === 2) {
      cars = data?.filter((x) => x.broker === "packmn");
    } else if (type === 3) {
      cars = data?.filter((x) => x.broker === "itools");
    } else if (type === 4) {
      cars = data?.filter((x) => x.status === "online");
    } else if (type === 5) {
      cars = data?.filter((x) => x.status === "offline");
    } else if (type === 6) {
      cars = data?.filter((x) => x.isactive === 1);
    }

    let tmp = cars?.map((item, i) => {
      return (
        <div className="border rounded-md p-2 shadow-sm h-fit">
          <div className="flex items-center justify-between">
            <span className="text-active font-semibold">{item.imei}</span>
            <span className="text-xs">{item.status}</span>
          </div>
          <span className="text-xs">
            {item.isactive === 1 ? "асаалттай" : "унтарсан"}
          </span>
          <div className="flex grid grid-cols-4">
            <div className="flex flex-col items-center">
              <span className="text-xs">Volt</span>
              <span>{item?.telemetry?.volt || 0}</span>
            </div>
            <div className="flex flex-col items-center">
              <span className="text-xs">Temp</span>
              <span>{item?.telemetry?.temperature || 0}</span>
            </div>
            <div className="flex flex-col items-center">
              <span className="text-xs">Temp S</span>
              <span>{item?.telemetry?.temperature2 || 0}</span>
            </div>
            <div className="flex flex-col items-center">
              <span className="text-xs">CSQ</span>
              <span>{item?.telemetry?.csq || 0}</span>
            </div>
          </div>
        </div>
      );
    });

    return tmp;
  };

  return (
    <div className="h-full flex flex-col">
      <Dash data={data} setType={setType} />
      {type !== 0 ? (
        <div className="mt-2">
          <Button icon={<ClearOutlined />} onClick={() => setType(0)} />
        </div>
      ) : null}

      <div className="relative h-full overflow-y-auto mt-2">
        <div className="absolute w-full left-0top-0 bottom-0 h-full flex flex-col grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-8 gap-2">
          {renderCars()}
        </div>
      </div>
    </div>
  );
};

export default Index;
